// extracted by mini-css-extract-plugin
export default {"checkmarkBoxContainer":"FormLocationPref_checkmarkBoxContainer__Rbfwi","pref":"FormLocationPref_pref__OkAmd"};